export default __webpack_public_path__ + "static/media/Graphics_postcard-03-min.63f6a2da.jpg";